export default __webpack_public_path__ + "static/media/project3-p3.1dbf0012.png";